// packages
import cx from 'classnames';
import { capfirst } from 'journalize';
import memoize from 'lodash.memoize';
import { h } from 'preact';

type Props = {
  excludeInitial?: boolean;
  party: string;
  style: string;
};

function PartyPill({ excludeInitial, party, style }: Props) {
  const partyPrefix = party.slice(0, 3).toLowerCase();
  const partyInitial = party[0].toUpperCase();

  const classes = cx('circle-pill', `pill--${partyPrefix}`);

  return (
    <span class={classes} style={style} title={capfirst(party)}>
      {!excludeInitial && partyInitial}
    </span>
  );
}

PartyPill.defaultProps = {
  excludeInitial: false,
};

export default memoize(PartyPill, ({ party, style }) => ({
  party: party,
  style: style,
}));
